export type ActId = 1 | 2 | 3 | 4 | 5;

export type ActConfig = {
  id: ActId;
  name: string;
  /** Start of act as fraction of run music/progress 0..1 */
  from: number;
  to: number;
  intensity: number;
  /** Multiplier on enemy bullet spawn rate */
  density: number;
};

/** Default ~6.5 min ritual mapped to progress 0..1 */
export const DEFAULT_ACTS: ActConfig[] = [
  { id: 1, name: "Alone", from: 0, to: 0.18, intensity: 0.25, density: 0.55 },
  { id: 2, name: "Weight", from: 0.18, to: 0.4, intensity: 0.5, density: 0.9 },
  { id: 3, name: "Offer", from: 0.4, to: 0.58, intensity: 0.7, density: 1.1 },
  { id: 4, name: "Together", from: 0.58, to: 0.82, intensity: 0.85, density: 1.25 },
  { id: 5, name: "Clear", from: 0.82, to: 1, intensity: 1, density: 1.35 },
];

export class ActDirector {
  acts: ActConfig[];
  progress = 0;
  current: ActConfig;

  constructor(acts: ActConfig[] = DEFAULT_ACTS) {
    this.acts = acts;
    this.current = acts[0]!;
  }

  /** progress 0..1 from music or elapsed/duration */
  setProgress(p: number): ActConfig {
    this.progress = Math.min(1, Math.max(0, p));
    const found =
      this.acts.find((a) => this.progress >= a.from && this.progress < a.to) ??
      this.acts[this.acts.length - 1]!;
    this.current = found;
    return found;
  }

  get intensity(): number {
    return this.current.intensity;
  }

  get density(): number {
    return this.current.density;
  }

  get finished(): boolean {
    return this.progress >= 1;
  }
}
